import {
	HttpContextToken,
	HttpEventType,
	HttpInterceptorFn,
	HttpUploadProgressEvent,
} from '@angular/common/http';
import { tap } from 'rxjs';

/**
 * Opt any generated API call into upload progress using its final HttpContext
 * argument: new HttpContext().set(UPLOAD_PROGRESS, event => ...).
 * NSwag's includeHttpContext option preserves this across regeneration.
 * Requires the XHR backend. The generated observable still returns the final DTO.
 */
export const UPLOAD_PROGRESS = new HttpContextToken<
	((event: HttpUploadProgressEvent) => void) | null
>(() => null);

export const uploadProgressInterceptor: HttpInterceptorFn = (request, next) => {
	const report = request.context.get(UPLOAD_PROGRESS);
	if (!report) return next(request);

	return next(request.clone({ reportProgress: true })).pipe(
		tap(event => {
			if (event.type === HttpEventType.UploadProgress) report(event);
		}),
	);
};
